import { type ReactElement, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import { useMeQuery, useMyCurrentAccountQuery } from '@/__generated__/hooks'

type Props = { children: ReactNode }

const AuthGuard = ({ children }: Props) => {
  const { t } = useTranslation()
  const me = useMeQuery()
  const acct = useMyCurrentAccountQuery({ skip: !me.data?.me })

  if (me.loading) {
    return (
      <main className="min-h-dvh grid place-items-center text-ink-500">
        {t('common.loading')}
      </main>
    )
  }

  if (me.error || !me.data?.me) {
    return <Navigate to="/login" replace />
  }

  if (acct.loading) {
    return (
      <main className="min-h-dvh grid place-items-center text-ink-500">
        {t('common.loading')}
      </main>
    )
  }

  if (!acct.data?.myCurrentAccount) {
    return <Navigate to="/account-select" replace />
  }

  return children as ReactElement
}

export default AuthGuard
